const labConnectionEn = {
	labConnectionEditForm: 'Lab Connection',
	labConnectionTable: 'Lab Connection',
	name: 'Name',
	hostName: 'Host Name',
	databaseName: 'Database Name',
	user: 'User',
	password: 'Password'
};

export default labConnectionEn;
